// rv-main-collection: loaded only where the section is used (sections/rv-main-collection.liquid)

// "Read more" for the collection description on mobile
class RvReadMore extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('[data-rv-read-more-text]');
    this.toggle = this.querySelector('[data-rv-read-more-toggle]');
    if (!this.text || !this.toggle) return;
    requestAnimationFrame(() => {
      this.toggle.hidden = this.text.scrollHeight <= this.text.clientHeight + 2;
    });
    this.toggle.addEventListener('click', () => {
      const expanded = !this.hasAttribute('expanded');
      this.toggleAttribute('expanded', expanded);
      this.toggle.setAttribute('aria-expanded', String(expanded));
      this.toggle.hidden = expanded;
    });
  }
}
if (!customElements.get('rv-read-more')) customElements.define('rv-read-more', RvReadMore);

// Mobile "Filter" / "Sort" bar: both open Horizon's filter drawer ("Sort" jumps to sorting)
class RvCollectionBar extends HTMLElement {
  connectedCallback() {
    // Keep the header count in step with the filtered results (this bar is re-rendered on each filter change).
    const headerCount = document.querySelector('[data-rv-header-count]');
    if (headerCount && this.dataset.total !== undefined) {
      const total = Number(this.dataset.total);
      const template = total === 1 ? headerCount.dataset.one : headerCount.dataset.many;
      headerCount.textContent = template.replace('[total]', String(total));
    }

    const drawer = () => document.getElementById('filters-drawer');
    if (!drawer()) this.setAttribute('data-no-filters', '');
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-rv-open]');
      const target = drawer();
      if (!button || !target || typeof target.open !== 'function') return;
      target.open();
      if (button.dataset.rvOpen === 'sort') {
        setTimeout(() => {
          const sorting = target.querySelector('[name="sort_by"]');
          const group = sorting?.closest('details, fieldset, .sorting-filter, .facets__item') || sorting;
          if (group instanceof HTMLDetailsElement) group.open = true;
          group?.scrollIntoView({ block: 'start', behavior: 'instant' });
          sorting?.focus({ preventScroll: true });
        }, 350);
      }
    });
  }
}
if (!customElements.get('rv-collection-bar')) customElements.define('rv-collection-bar', RvCollectionBar);

// "Charger plus": loads the next page into the grid and updates "24 of 86 items"
class RvLoadMore extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = async (event) => {
    const button = event.target.closest('[data-rv-load-more]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');

    const section = this.closest('results-list');
    const url = new URL(button.href, window.location.origin);
    url.searchParams.set('section_id', section.getAttribute('section-id'));

    const parse = async (requestUrl) => {
      const html = await fetch(requestUrl).then((response) => response.text());
      return new DOMParser().parseFromString(html, 'text/html');
    };

    try {
      // Section-only response first; if it has no products, fall back to the full page.
      let fresh = await parse(url);
      let items = fresh.querySelectorAll('.rv-collection__grid > .rv-collection__item');
      if (!items.length) {
        fresh = await parse(button.href);
        items = fresh.querySelectorAll('.rv-collection__grid > .rv-collection__item');
      }
      if (!items.length) throw new Error('No products in the next page');

      const grid = section.querySelector('.rv-collection__grid');
      items.forEach((item) => grid.append(item));

      const nextButton = fresh.querySelector('[data-rv-load-more]');
      if (nextButton) button.href = nextButton.getAttribute('href');
      else button.remove();

      const shown = grid.querySelectorAll('.rv-collection__item').length;
      const total = Number(this.dataset.total);
      this.querySelector('[data-rv-count]').textContent = this.dataset.template
        .replace('[x]', String(shown))
        .replace('[total]', String(total));
      const progress = this.querySelector('[data-rv-progress]');
      if (progress && total) progress.style.width = `${(shown / total) * 100}%`;
    } catch (error) {
      window.location.href = button.href;
    } finally {
      button.removeAttribute('aria-busy');
    }
  };
}
if (!customElements.get('rv-load-more')) customElements.define('rv-load-more', RvLoadMore);
